import { ITypedReduxAction } from '../../../types/redux/actionType';
import { ISettings } from '../../../types/settings';

export enum ESetPageTypeActionType {
  Set = 'settings/setPageType',
}

export type TSetPageType = ITypedReduxAction<ESetPageTypeActionType.Set, ISettings['pageType']>;
